/* eslint-disable no-unused-vars */
import moment from 'moment';
import React from 'react';
import { CSVLink } from 'react-csv';
import Xlxs from '../../../../../../../../assets/icons/Xlsx2';
import Table from '../../../../../../../../shared/components/Wrapper/Table';
import { convertToReal } from '../../../../../../../../utils/values';
import { IExportCsv } from './interface';

function ExportCsv(props: IExportCsv) {
  const { data } = props;
  const fileName = `Relatório de Fechamento de ${moment(
    props.data.dateSearch.start
  ).format('DD-MM-YY')} até ${moment(props.data.dateSearch.end).format(
    'DD-MM-YY'
  )}.csv`;

  const content = [
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Recebimento de TED',
      code: 'STR0008R2',
      value: convertToReal(data.recebimento_transferencia_externa.STR0008R2),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Estorno de TED',
      code: 'STR0010R2',
      value: convertToReal(data.recebimento_transferencia_externa.STR0010R2),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Recebimento de IF para IF',
      code: 'STR0006R2',
      value: convertToReal(data.recebimento_transferencia_externa.STR0006R2),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Recebimento de TED',
      code: 'STR0007R2',
      value: convertToReal(data.recebimento_transferencia_externa.STR0007R2),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Pix',
      code: 'Pix',
      value: convertToReal(data.recebimento_transferencia_externa.Pix),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Pix Devolução',
      code: 'Pix_Devolucao',
      value: convertToReal(
        data.recebimento_transferencia_externa.Pix_Devolucao
      ),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Recebimento de TRANSFERÊNCIAS de outra IF',
      code: 'STR0004R2_FGTS',
      value: convertToReal(
        data.recebimento_transferencia_externa.STR0004R2_FGTS
      ),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Recebimento de TRANSFERÊNCIAS de outra IF',
      code: 'STR0004R2 (FIDÚCIA INVEST)',
      value: convertToReal(
        data.recebimento_transferencia_externa.STR0004R2_INVEST
      ),
    },
    {
      index: 'ENVIO DE TRANSFERÊNCIAS EXTERNAS',
      description: 'Recebimento de TRANSFERÊNCIAS de outra IF',
      code: 'TED',
      value: convertToReal(data.envio_transferencia_externa.STR0008),
    },
    {
      index: 'ENVIO DE TRANSFERÊNCIAS EXTERNAS',
      description: 'Pix',
      code: 'PIX',
      value: convertToReal(data.envio_transferencia_externa.Pix),
    },
    {
      index: 'ENVIO DE TRANSFERÊNCIAS EXTERNAS',
      description: 'Pix devolução',
      code: 'PIX devolução',
      value: convertToReal(data.envio_transferencia_externa.Pix_Devolucao),
    },
    {
      index: 'RECEBIMENTO DE DOMICÍLIO BANCÁRIO',
      description: 'Fluxo de Crédito - CIP',
      code: 'ASLC022',
      value: convertToReal(data.recebimento_domicilio_bancario.ASLC022),
    },
    {
      index: 'RECEBIMENTO DE DOMICÍLIO BANCÁRIO',
      description: 'Fluxo de Débito - CIP',
      code: 'ASLC032',
      value: convertToReal(data.recebimento_domicilio_bancario.ASLC032),
    },
    {
      index: 'RECEBIMENTO DE DOMICÍLIO BANCÁRIO',
      description: 'Fluxo de Antecipação - CIP',
      code: 'ASLC024',
      value: convertToReal(data.recebimento_domicilio_bancario.ASLC024),
    },
    {
      index: 'ENVIO DE TRANSFERÊNCIAS INTERNAS',
      description: 'TEV Interna',
      code: 'STR0008',
      value: convertToReal(data.envio_transferencia_interna.STR0008),
    },
    {
      index: 'ENVIO DE TRANSFERÊNCIAS INTERNAS PARA CONTAS DE TERCEIROS',
      description: 'TEV Interna',
      code: 'STR0008',
      value: convertToReal(
        data.envio_transferencia_interna_conta_terceiros.STR0008
      ),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS INTERNAS DE CONTAS FIDÚCIA',
      description: 'TEV Interna',
      code: 'STR0008',
      value: convertToReal(
        data.recebimento_transferencia_interna_conta_fiducia.STR0008
      ),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de Pix',
      code: 'TARIFA_PIX',
      value: convertToReal(data.recebimento_tarifas.TARIFA_PIX),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa ao gerar QRCode',
      code: 'TARIFA_PIX_GERAR_QRCODE',
      value: convertToReal(data.recebimento_tarifas.TARIFA_PIX_GERAR_QRCODE),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Recebimento de TRANSFERÊNCIAS de outra IF',
      code: 'STR0004R2 (TIB)',
      value: convertToReal(data.recebimento_tarifas.STR0004R2),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de TED',
      code: 'STR0004',
      value: convertToReal(data.recebimento_tarifas.TAXA_TED),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de boleto liquidado',
      code: 'TARIFA_BOLETO',
      value: convertToReal(data.recebimento_tarifas.TARIFA_BOLETO),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa genérica',
      code: 'TARIFA',
      value: convertToReal(data.recebimento_tarifas.TARIFA),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de boleto vencido',
      code: 'TARIFA_BOLETO_VENCIDO',
      value: convertToReal(data.recebimento_tarifas.TARIFA_BOLETO_VENCIDO),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de mensalidade',
      code: 'TARIFA_MENSAL',
      value: convertToReal(data.recebimento_tarifas.TARIFA_MENSAL),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de alteração de boleto',
      code: 'TARIFA_ALTERACAO_BOLETO',
      value: convertToReal(data.recebimento_tarifas.TARIFA_ALTERACAO_BOLETO),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de boleto baixado',
      code: 'TARIFA_BAIXADO',
      value: convertToReal(data.recebimento_tarifas.TARIFA_BAIXADO),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de abertura de conta PF',
      code: 'TARIFA_ABERTURA_CONTA_PF',
      value: convertToReal(data.recebimento_tarifas.TARIFA_ABERTURA_CONTA_PF),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de abertura de conta PJ',
      code: 'TARIFA_ABERTURA_CONTA_PJ',
      value: convertToReal(data.recebimento_tarifas.TARIFA_ABERTURA_CONTA_PJ),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de abertura de conta escrow',
      code: 'TARIFA_ABERTURA_CONTA_ESCROW',
      value: convertToReal(
        data.recebimento_tarifas.TARIFA_ABERTURA_CONTA_ESCROW
      ),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de abertura de conta Consignada',
      code: 'TARIFA_ABERTURA_CONTA_CONSIGNADA',
      value: convertToReal(
        data.recebimento_tarifas.TARIFA_ABERTURA_CONTA_CONSIGNADA
      ),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de recebimento de Pix',
      code: 'TARIFA_RECEBIMENTO_PIX',
      value: convertToReal(data.recebimento_tarifas.TARIFA_RECEBIMENTO_PIX),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de recebimento de Pix Devolução',
      code: 'TARIFA_RECEBIMENTO_PIX_DEVOLUCAO',
      value: convertToReal(
        data.recebimento_tarifas.TARIFA_RECEBIMENTO_PIX_DEVOLUCAO
      ),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de recebimento de TED',
      code: 'TARIFA_RECEBIMENTO_TED',
      value: convertToReal(data.recebimento_tarifas.TARIFA_RECEBIMENTO_TED),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de recebimento de TEV',
      code: 'TARIFA_RECEBIMENTO_TEV',
      value: convertToReal(data.recebimento_tarifas.TARIFA_RECEBIMENTO_TEV),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de recebimento de Boleto',
      code: 'TARIFA_RECEBIMENTO_BOLETO',
      value: convertToReal(data.recebimento_tarifas.TARIFA_RECEBIMENTO_BOLETO),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de recebimento de Domicílio bancário',
      code: 'TARIFA_RECEBIMENTO_DOMICILIO',
      value: convertToReal(
        data.recebimento_tarifas.TARIFA_RECEBIMENTO_DOMICILIO
      ),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de venda Cripto',
      code: 'TARIFA_CRIPTO_VENDA',
      value: convertToReal(data.recebimento_tarifas.TARIFA_CRIPTO_VENDA),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de compra Cripto',
      code: 'TARIFA_CRIPTO_COMPRA',
      value: convertToReal(data.recebimento_tarifas.TARIFA_CRIPTO_COMPRA),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de saque no Cartão',
      code: 'TARIFA_CARTAO_SAQUE',
      value: convertToReal(data.recebimento_tarifas.TARIFA_CARTAO_SAQUE),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de solicitação de Cartão',
      code: 'TARIFA_CARTAO_SOLICITACAO',
      value: convertToReal(data.recebimento_tarifas.TARIFA_CARTAO_SOLICITACAO),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de saque no Cartão',
      code: 'TARIFA_CARTAO_SAQUE',
      value: convertToReal(data.recebimento_tarifas.TARIFA_CARTAO_SAQUE),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de solicitação de Cartão',
      code: 'TARIFA_CARTAO_SOLICITACAO',
      value: convertToReal(data.recebimento_tarifas.TARIFA_CARTAO_SOLICITACAO),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de Pix',
      code: 'TAXA_TED',
      value: convertToReal(data.repasse_tarifas.TAXA_TED),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Recebimento de TRANSFERÊNCIAS para outra IF',
      code: 'SLB0002',
      value: convertToReal(data.repasse_tarifas.SLB0002),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de TED',
      code: 'STR0004',
      value: convertToReal(data.repasse_tarifas.STR0004),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de Pix',
      code: 'TARIFA_PIX',
      value: convertToReal(data.repasse_tarifas.TARIFA_PIX),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de recebimento de TED',
      code: 'TARIFA_RECEBIMENTO_TED',
      value: convertToReal(data.repasse_tarifas.TARIFA_RECEBIMENTO_TED),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de recebimento de TEV',
      code: 'TARIFA_RECEBIMENTO_TEV',
      value: convertToReal(data.repasse_tarifas.TARIFA_RECEBIMENTO_TEV),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de recebimento de Boleto',
      code: 'TARIFA_RECEBIMENTO_BOLETO',
      value: convertToReal(data.repasse_tarifas.TARIFA_RECEBIMENTO_BOLETO),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de recebimento de Domicílio bancário',
      code: 'TARIFA_RECEBIMENTO_DOMICILIO',
      value: convertToReal(data.repasse_tarifas.TARIFA_RECEBIMENTO_DOMICILIO),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de boleto liquidado',
      code: 'TARIFA_BOLETO',
      value: convertToReal(data.repasse_tarifas.TARIFA_BOLETO),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa genérica',
      code: 'TARIFA',
      value: convertToReal(data.repasse_tarifas.TARIFA),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa Boleto vencido',
      code: 'TARIFA_BOLETO_VENCIDO',
      value: convertToReal(data.repasse_tarifas.TARIFA_BOLETO_VENCIDO),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa Mensal',
      code: 'TARIFA_MENSAL',
      value: convertToReal(data.repasse_tarifas.TARIFA_MENSAL),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa Alteração de Boleto',
      code: 'TARIFA_ALTERACAO_BOLETO',
      value: convertToReal(data.repasse_tarifas.TARIFA_ALTERACAO_BOLETO),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de Boleto baixado',
      code: 'TARIFA_BAIXADO',
      value: convertToReal(data.repasse_tarifas.TARIFA_BAIXADO),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de abertura de conta PF',
      code: 'TARIFA_ABERTURA_CONTA_PF',
      value: convertToReal(data.repasse_tarifas.TARIFA_ABERTURA_CONTA_PF),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de abertura de conta PJ',
      code: 'TARIFA_ABERTURA_CONTA_PJ',
      value: convertToReal(data.repasse_tarifas.TARIFA_ABERTURA_CONTA_PJ),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de abertura de conta Escrow',
      code: 'TARIFA_ABERTURA_CONTA_ESCROW',
      value: convertToReal(data.repasse_tarifas.TARIFA_ABERTURA_CONTA_ESCROW),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de abertura de conta Consignada',
      code: 'TARIFA_ABERTURA_CONTA_CONSIGNADA',
      value: convertToReal(
        data.repasse_tarifas.TARIFA_ABERTURA_CONTA_CONSIGNADA
      ),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de recebimento de Pix',
      code: 'TARIFA_RECEBIMENTO_PIX',
      value: convertToReal(data.repasse_tarifas.TARIFA_RECEBIMENTO_PIX),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de recebimento Pix Devolução',
      code: 'TARIFA_RECEBIMENTO_PIX_DEVOLUCAO',
      value: convertToReal(
        data.repasse_tarifas.TARIFA_RECEBIMENTO_PIX_DEVOLUCAO
      ),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de venda Cripto',
      code: 'TARIFA_CRIPTO_VENDA',
      value: convertToReal(data.repasse_tarifas.TARIFA_CRIPTO_VENDA),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de compra Cripto',
      code: 'TARIFA_CRIPTO_COMPRA',
      value: convertToReal(data.repasse_tarifas.TARIFA_CRIPTO_COMPRA),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de saque no Cartão',
      code: 'TARIFA_CARTAO_SAQUE',
      value: convertToReal(data.repasse_tarifas.TARIFA_CARTAO_SAQUE),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de solicitação de Cartão',
      code: 'TARIFA_CARTAO_SOLICITACAO',
      value: convertToReal(data.repasse_tarifas.TARIFA_CARTAO_SOLICITACAO),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa ao gerar QRCode',
      code: 'TARIFA_PIX_GERAR_QRCODE',
      value: convertToReal(data.repasse_tarifas.TARIFA_PIX_GERAR_QRCODE),
    },
    {
      index: 'RECEBIMENTO DE BOLETO ITAÚ',
      description: 'Recebimento de boleto',
      code: 'BOLETO_CREDITO',
      value: convertToReal(data.recebimento_boleto_itau.BOLETO_CREDITO),
    },
    {
      index: 'RECEBIMENTO DE BOLETOS CONTA FIDÚCIA',
      description: 'Recebimento de boleto',
      code: 'BOLETO_CREDITO',
      value: convertToReal(data.recebimento_boleto_fiducia.BOLETO_CREDITO),
    },
    {
      index: 'RECEBIMENTO DE BOLETOS CONTA TERCEIROS',
      description: 'Boletos liquidados para terceiros',
      code: 'BOLETO_CREDITO',
      value: convertToReal(data.recebimento_boleto_terceiros.BOLETO_CREDITO),
    },
    {
      index: 'PAGAMENTO DE BOLETOS',
      description: 'Pagamento de boleto',
      code: 'BOLETO_CREDITO',
      value: convertToReal(data.recebimento_boleto_terceiros.BOLETO_CREDITO),
    },
    {
      index: 'RECEBIMENTO BOLETO',
      description: 'Recebimeneto de boleto',
      code: 'BOLETO_CREDITO',
      value: convertToReal(data.recebimento_boleto.BOLETO_CREDITO),
    },
    {
      index: 'RECEBIMENTO BOLETO',
      description: 'Recebimeneto de boleto',
      code: 'BOLETO',
      value: convertToReal(data.recebimento_boleto.Boleto),
    },
    {
      index: 'PAGAMENTO DE BOLETOS',
      description: 'Pagamento de boleto',
      code: 'Boleto',
      value: convertToReal(data.pagamento_boleto.Boleto),
    },
    {
      index: 'RECEBIMENTO DE RECARGAS',
      description: 'Recarga',
      code: 'Recarga',
      value: convertToReal(data.recebimento_recarga.Recarga),
    },
    {
      index: 'PAGAMENTO DE RECARGAS',
      description: 'Recarga',
      code: 'Recarga',
      value: convertToReal(data.pagamento_recarga.Recarga),
    },
    {
      index: 'ENVIO CARTÃO',
      description: 'Compra via cartão',
      code: 'CARTAO_00_PURCHASE',
      value: convertToReal(data.envio_cartao.CARTAO_00_PURCHASE),
    },
    {
      index: 'ENVIO CARTÃO',
      description: 'Saque via cartão#',
      code: 'CARTAO_01_CASH_WITHDRAW',
      value: convertToReal(data.envio_cartao.CARTAO_01_CASH_WITHDRAW),
    },
    {
      index: 'RECEBIMENTO CARTÃO',
      description: 'Compra via cartão',
      code: 'CARTAO_00_PURCHASE',
      value: convertToReal(data.recebimento_cartao.CARTAO_00_PURCHASE),
    },
    {
      index: 'RECEBIMENTO DO CARTÃO',
      description: 'Saque via cartão',
      code: 'CARTAO_01_CASH_WITHDRAW',
      value: convertToReal(data.recebimento_cartao.CARTAO_01_CASH_WITHDRAW),
    },
  ];

  const header = [
    { label: 'INDEX', key: 'index' },
    { label: 'DESCRIÇÃO', key: 'description' },
    { label: 'CÓDIGO', key: 'code' },
    { label: 'VALOR', key: 'value' },
  ];

  return (
    <CSVLink data={content} headers={header} filename={fileName}>
      <Table.Button>
        <Xlxs /> Download em Excel
      </Table.Button>
    </CSVLink>
  );
}

export default ExportCsv;
